
import Switch from '@mui/material/Switch';
import { useState } from 'react';
import api from '../../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import LoadingShort from '../../../load/loadingShort';
import { SILENT_LOGIN } from '../../../actions/accountActions';

export default function ButtonSwitch({ title, permission, permissions, setPermission, descricao, adminId, verificacaoSimples, width }) {
  const user = useSelector((state) => state.account.user);
  const [load, setLoad] = useState(false);
  const dispatch = useDispatch();

  async function togglePermission() {
    setLoad(true);

    await api.patch("/admin/toggle-permission", {
      userId: user._id,
      adminId,
      descricao,
      permission,
    }).then((response) => {

      //  ACTUAALIZAR OS DADOS DO USER NA ESTADO DA APLICAÇÃO
      if (user?._id === response.data.user._id) {
        // clona o objeto user da API e substitui o fotoURL
        const updatedUser = {
          ...response.data.user,
          dadosPessoais: {
            ...response.data.user.dadosPessoais,
            fotoURL: user?.dadosPessoais?.fotoURL
          }
        };

        dispatch({
          type: SILENT_LOGIN,
          payload: {
            user: updatedUser,
          },
        });
      }
      // console.log(response)
      setPermission(response.data.permissions)
    })
      .catch((error) => {
        // console.log(error)
      }).finally(() => setLoad(false))
  }


  return (
    <div style={{ width: width ?? 350, display: 'flex', alignItems: 'center', marginLeft: 5 }}>

      <span style={{ flexGrow: 1 }}>
        {title}
      </span>

      {load ?
        <LoadingShort />
        :
        <Switch
          color='secondary'
          style={{ width: 50 }}
          checked={permissions.includes(permission) || permissions.includes(verificacaoSimples ? permission : 'allPermissions')}
          onChange={togglePermission}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      }
    </div>
  );
}
